import React from 'react';
import { Button, ButtonProps } from '@patternfly/react-core';
import { PURPLE_GRADIENT, PURPLE_GRADIENT_DISABLED, colors, radii, shadows } from '@app/components/designTokens';

type Variant = 'primary' | 'secondary' | 'danger';

interface GradientButtonProps extends Omit<ButtonProps, 'variant'> {
    appearance?: Variant;
}

const baseStyle: React.CSSProperties = {
    border: 'none',
    padding: '13px 24px',
    fontSize: 15,
    fontWeight: 600,
    borderRadius: radii.button
};

const primaryStyle: React.CSSProperties = {
    ...baseStyle,
    background: PURPLE_GRADIENT,
    color: '#ffffff',
    boxShadow: shadows.primaryButton
};

const primaryDisabledStyle: React.CSSProperties = {
    ...baseStyle,
    background: PURPLE_GRADIENT_DISABLED,
    color: '#ffffff',
    boxShadow: 'none',
    cursor: 'not-allowed'
};

const secondaryStyle: React.CSSProperties = {
    ...baseStyle,
    background: '#ffffff',
    color: colors.body,
    border: `1px solid ${colors.border}`,
    boxShadow: 'none'
};

const dangerStyle: React.CSSProperties = {
    ...baseStyle,
    background: colors.danger,
    color: '#ffffff',
    boxShadow: '0 6px 18px rgba(220, 38, 38, 0.3)'
};

const GradientButton: React.FC<GradientButtonProps> = ({
    appearance = 'primary',
    isDisabled,
    isLoading,
    style,
    ...rest
}) => {
    let resolved: React.CSSProperties;
    if (appearance === 'secondary') {
        resolved = secondaryStyle;
    } else if (appearance === 'danger') {
        resolved = dangerStyle;
    } else {
        resolved = (isDisabled || isLoading) ? primaryDisabledStyle : primaryStyle;
    }

    return (
        <Button
            variant="primary"
            isDisabled={isDisabled}
            isLoading={isLoading}
            style={{ ...resolved, ...style }}
            {...rest}
        />
    );
};

export { GradientButton };
